import React from "react";
import "./Testimonials.css";

export default function Testimonials() {
  return (
    <section className="testimonials" id="testimonials" data-aos="fade-up">
      <h2 className="section-title1">What Clients Say</h2>

      <div className="testimonial-grid">
        {[1, 2, 3].map((item) => (
          <div className="testimonial-card" key={item} data-aos="zoom-in">
            <p className="testimonial-text">
              "Fantastic service and great quality! Highly recommend."
            </p>
            <h4 className="testimonial-author">— Client {item}</h4>
          </div>
        ))}
      </div>
    </section>
  );
}
